import { PaymentMethod } from '@api/GoodocAPI';
import FocusableIconButton from '@components/FocusableIconButton';
import { UseFocusableConfig } from '@noriginmedia/norigin-spatial-navigation';
import { FC, useCallback, useMemo } from 'react';

import * as styles from './styles';

interface PaymentButtonProps extends UseFocusableConfig {
  paymentMethod: Partial<PaymentMethod>;
}

const PaymentButton: FC<PaymentButtonProps> = ({
  paymentMethod,
  focusKey,
  onEnterPress
}) => {
  // FIXME: change to `ProviderType`
  const getProviderName = useCallback((provider: string) => {
    switch (provider) {
      case 'nicepay':
        return '나이스페이';
      case 'kakaopay':
        return '카카오페이';
    }
    return '';
  }, []);
  // FIXME: change to `ProviderType`
  const getPaymentCardName = useCallback(
    (provider: string, cardName: string) => {
      if (provider && cardName) {
        return `${getProviderName(provider)} - ${cardName}`;
      } else if (provider && !cardName) {
        return getProviderName(provider);
      } else if (!provider && cardName) {
        return cardName;
      }
      return '';
    },
    [getProviderName]
  );

  const [providerFocusedStyle, providerFocusedIconStyle] = useMemo(() => {
    switch (paymentMethod.provider) {
      case 'kakaopay':
        return [styles.focusedKakaoButton, styles.focusedKakaoButtonIcon];
    }
    return [];
  }, [paymentMethod.provider]);

  return (
    <FocusableIconButton
      focusKey={focusKey}
      onEnterPress={onEnterPress}
      iconType="check"
      focusedStyle={providerFocusedStyle}
      iconFocusedStyle={providerFocusedIconStyle}
    >
      <span>
        {getPaymentCardName(paymentMethod.provider ?? '', paymentMethod.cardName ?? '')}
        {paymentMethod.status === 'paidFailure' && (
          <span css={styles.failed}> (결제실패)</span>
        )}
      </span>
    </FocusableIconButton>
  );
};

export default PaymentButton;
